/**
 * Not found (SHELL-012, SHELL-013).
 *
 * Rendered both by the router's default route and directly by a screen that
 * matched a route pattern but was handed an id for something that does not
 * exist. Those are the same thing to a player and should look the same.
 */

import { Screen } from '@shell/Screen';
import { routes } from '@shell/routes';

export function NotFound() {
  return (
    <Screen title="Page not found">
      <p>That address does not lead anywhere in Puzzle Gate.</p>
      <nav class="screen-nav">
        <a class="nav-link" href={routes.picker()}>
          Back to the game picker
        </a>
      </nav>
    </Screen>
  );
}
